export default "__VITE_ASSET__BHLd49MJ__"